var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 200.093H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 200.093z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V311.909h512v102.988a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#464655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 200.091h512v111.81H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.186 238.571c0-4.377-4.289-7.469-8.441-6.084l-7.804 2.601-1.895-11.444a14.047 14.047 0 0 0-13.906-11.78h-7.299l-7.634 9.396h10.109l-2.829 13.972-8.233-2.744c-4.153-1.385-8.441 1.707-8.441 6.084v47.475l11.363-11.363-5.354 16.061h-6.008v9.396h56.373v-9.396h-6.008l-5.354-16.061 11.363 11.363v-47.476h-.002zm-32.883 52.172h-7.574l5.208-13.909 2.366 3.021v10.888zm9.394 0v-10.888l2.366-3.021 5.208 13.909h-7.574zM256 273.714s-14.534-9.836-13.946-28.186c0 0 8.956-1.468 13.946-9.396 4.991 7.927 13.947 9.396 13.947 9.396.587 18.351-13.947 28.186-13.947 28.186z",
    fill: "#f0c727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/eg.d95615012a487ecadde79e51bd2ab78b.svg";
export { ForwardRef as ReactComponent };